<div id="container-home-page">
  <div
    class="row justify-content-center align-items-center px-5 pt-5 pb-0 home-page-light-blue-bg-color">
    <div class="col-6 text-center text-black mt-4">
      <h2 class="fw-bold font-size-40">
        Gather Real-Time Feedback and Community Insights
      </h2>
      <p class="my-4 font-size-16">
        Stay attuned to the needs of your staff, residents, and their family
        members with our innovative survey and feedback platform.
      </p>
      <a
        class="btn btn-lg schedule-demo-button px-5 text-white mt-3 mb-4"
        href="https://get.tsolife.com/contact-us"
        target="_blank">
        Get Started
      </a>
    </div>
    <div class="col-7">
      <img
        class="card-img img-fluid"
        src="assets/images/survey-feedback-platform/survey-hero.png"
        alt="Resident Insights Hero" />
    </div>
  </div>

  <div class="row justify-content-center bg-white mt-0">
    <div class="col-6 text-center text-black mt-5">
      <h2>Revolutionizing the Feedback and Resolution Process</h2>
      <p class="mt-4 font-size-17">
        With real-time insights, automated investigations, and instant
        resolution strategies, our survey and feedback platform empowers users
        to achieve exceptional results, providing an accurate, in-depth view of
        their community's performance at any given time.
      </p>
    </div>
  </div>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body mtb-50">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Access Community Insights and Feedback
          </h2>
          <p class="card-text img-info-body">
            Structured surves and pulse surves provide a streamlined and
            efficient method for collecting input from staff, residents, and
            family members.
            <br />
            <br />
            The platform efficiently monitors survey distribution, responses,
            overdue surveys, and triggered investigations, offering valuable
            insights for continuous improvements.
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/survey-feedback-platform/access-community-insights.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row">
      <div class="offset-md-1 col-md-5">
        <div class="card-body">
          <img
            class="card-img img-fluid"
            src="assets/images/survey-feedback-platform/unlock-automated-solutions.png"
            alt="TSOLife Calendar" />
        </div>
      </div>

      <div class="col-md-5 d-flex align-items-center">
        <div class="card-body">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Unlock Automated Solutions for Effective Resolution
          </h2>
          <p class="card-text img-info-body">
            The platform goes beyond simple information collection by
            proactively addressing concerns through automated investigations and
            resolution strategies.
            <br />
            <br />
            With a curated and comprehensive library of intervention courses,
            users can alleviate the burden of time-consuming planning, enabling
            them to swiftly and effectively address issues which in turn
            contributes to enhanced experiences and satisfaction.
          </p>
        </div>
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body mtb-50">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Explore Insightful Metrics with Feedback Dashboards
          </h2>
          <p class="card-text img-info-body">
            Our comprehensive dashboards provide detailed insights into survey
            responses, presenting key metrics like response rates, active and
            resolved investigations, speed-to-solution rate, and more.
            <br />
            <br />
            This information empowers corporate and community-level users to
            quickly identify positive or negative changes since the last survey,
            facilitating targeted improvements.
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/survey-feedback-platform/key-metrics-for-optimization.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <div class="row justify-content-center p-5 text-white schedule-demo-bg-color">
    <div class="col-5 my-4">
      <h2 class="text-center">Ready to get started ?</h2>
      <p class="text-center mt-4 font-size-20">
        Get a firsthand look at how our platform is enabling operators to
        deliver exceptional resident experiences and thrive in an ever-evolving
        industry landscape.
      </p>
      <div class="d-flex justify-content-center mt-4">
        <a
          class="btn btn-lg btn-outline-light mx-auto"
          href="https://calendly.com/tsolife-david-sawyer/60min"
          target="_blank">
          Schedule Demo
        </a>
      </div>
    </div>
  </div>
</div>
